const typing = (state = [], action) => {
    switch (action.type) {
      case 'TYPING_ADD':
      return [
          ...state,{
            type: "TYPING",
            typing: action.typing,
            idatendimento: action.idatendimento
          }
        ]
        case 'TYPING_EDIT':
        return state.map(todo =>
          todo.idatendimento === action.idatendimento ?
            { ...todo, typing: action.typing } :
            todo
        )      
      default:
        return state
    }
  }
  
  export default typing